import { createStyles, makeStyles } from '@mui/styles';
import { Theme } from '@mui/material/styles';

const useStatusTagStyles = makeStyles((theme: Theme) =>
  createStyles({
    tag: {
      padding: 5,
      textAlign: 'center',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      height: 30,
      width: 85,
      fontWeight: '550',
      borderRadius: 2,
      color: 'white',
      '&.LeadOnly': {
        backgroundColor: 'rgba(58,159,191, 0.8)',
      },
      '&.Request': {
        backgroundColor: 'rgba(240,0,0, 0.8)',
      },
      '&.Complete': {
        backgroundColor: 'rgba(0,100,0, 0.8)',
      },
      '&.InProgress': {
        backgroundColor: 'rgba(0,60, 146, 0.8)',
      },
      '&.OnHold': {
        backgroundColor: 'rgba(245,118, 26, 0.8)',
      },
    },
  })
);

export default useStatusTagStyles;
